import { getAPI } from "./axios-base";

export default class RestResourceManufacturer {
  getManufacturers(params: { skip: number; limit: number }) {
    return getAPI.get("api/rest/v1/engine-manufacturers", {
      params: params
    });
  }
  postManufacturer(body: any) {
    return getAPI.post("api/rest/v1/engine-manufacturers", body);
  }
  getManufacturer(id: string) {
    return getAPI.get(`api/rest/v1/engine-manufacturers/${id}`);
  }
  putManufacturer(id: string, body: any) {
    return getAPI.put(`api/rest/v1/engine-manufacturers/${id}`, body);
  }
}
